import InteractiveAnnotation from "./interactiveAnnotation";
import { setLineStyle, boxSize, measureText, setFontStyle } from "../canvasUtils";
import { getArcPosition } from "../geometry";

export default class Circle extends InteractiveAnnotation {
  constructor(x, y, radius, text, options) {
    super({x, y}, options);
    this.centerX = x;
    this.centerY = y;
    this.radius = radius;

    this.text = text;
    this.textOffset = text && measureText(this.text) / 2;
    
    this.isActive = false;
  }

  draw(ctx) {
    this.drawCircle(ctx);

    if (this.text) this.drawText(ctx);
  }

  drawCircle(ctx){
    setLineStyle(ctx, this);
    ctx.beginPath();
    ctx.arc(this.centerX, this.centerY, this.radius, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.closePath();
  }

  drawText(ctx){
    setFontStyle(ctx, this);
    ctx.fillText(this.text, this.centerX - this.textOffset, this.centerY - this.radius - this.textSize);
  }

  isInBounds(x, y) {
    return this.isOnCircle(x, y) || (this.text && this.isInBoundsText(x, y));
  }

  isInBoundsText(x, y){
    return x >= this.centerX - this.textOffset && x <= this.centerX + this.textOffset * 2
      && y >= this.centerY - this.radius - 30 && y <= this.centerY - this.radius;
  }

  isOnCircle(x, y){
    let dx = x - this.centerX;
    let dy = y - this.centerY;
    let angle = Math.atan2(dy, dx);
    let pos = getArcPosition(this.centerX, this.centerY, this.radius, this.radius, angle);
    let diffX = Math.abs(x - pos.x);
    let diffY = Math.abs(y - pos.y);
    return diffX <= boxSize && diffY <= boxSize;
  }

  mousedown(x, y) {
    super.mousedown(x, y);
    this.isActive = true;
  }

  mousemove(x, y) {
    const { dx, dy } = this.getAndUpdateInteraction(x, y);
    this.centerX += dx;
    this.centerY += dy;
  }

  deactivate() {
    this.isActive = false;
  }
}